import { render, staticRenderFns } from "./MonetaryForm.vue?vue&type=template&id=86effcc8&"
import script from "./MonetaryForm.vue?vue&type=script&lang=js&"
export * from "./MonetaryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports